import { FlowTypes, PlanCodes } from 'utils/enums';

import { MembershipPlan } from 'models/plans.types';

export const getApptAdvantages = (
  selectedPlan?: MembershipPlan,
  selectedFlow?: FlowTypes,
  isCompoundMedication?: boolean
) => {
  if (!selectedPlan) {
    return [];
  }

  const advantages = [
    'Comprehensive video consultation with your selected provider.',
    'Prescriptions to medication will be written if medically appropriate.'
  ];
  if (
    selectedFlow !== FlowTypes.BlueLineFlow &&
    selectedFlow !== FlowTypes.WeightManagementBalladHealth &&
    selectedFlow !== FlowTypes.WeightManagementFlowInsuranceDiscovery &&
    !isCompoundMedication
  ) {
    advantages.push(
      'Save up to an additional 92% on your medication with your LifeMD Rx discount card.'
    );
  }
  if (selectedPlan.planCode === PlanCodes.FlexCare) {
    advantages.push('Free 90 days of follow-up care and messaging with your LifeMD care team.');
  } else {
    advantages.push('Unlimited follow-up care and messaging with your LifeMD care team.');
  }
  return advantages;
};
